import { useMutation } from 'react-query';

import { ResetPasswordTokenDto } from 'interfaces/authInterface';
import { authService } from 'services';

export default function useMutationPasswordRecoveryToken() {
  return useMutation((values: ResetPasswordTokenDto) => authService.resetPasswordToken(values));
}
